import React, { Component } from 'react'
import Button from 'components/button/button'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'

class ModalConfirm extends Component {
	doAction = (callback = null) => {
		if(callback){
			callback()
		}

		this.props.closeCallback()
	}

	render() {
		const {
			data
		} = this.props

		let className = 'modal-task borders'

		if(data.text.length > 70){
			className += ' long-text'
		}

		return(
			<div>
				<div className={className}>
					<h3 dangerouslySetInnerHTML={{ __html: data.text }} />
				</div>
				{ data.buttons ?
					data.buttons.map((button,index) => {
						return (
							<Button
								size={'big'}
								level={button.level}
								callback={_ => {this.doAction(button.callback)}}
								label={button.label}
								icon={button.level == 'high' ? 'check' : 'times'}
								key={index}
							/>
						)
					})			
				:
					<Button 
						size={'big'} 
						level={'high'} 
						callback={_ => {this.doAction()}}
						label={'Cool!'} 
						icon={'check'} 
					/>
				}
			</div>
		);
	}
}

export default withRouter(connect(null,null)(ModalConfirm))



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-confirm.jsx